import styled from 'styled-components';

import { pxToRem } from '../../../utils/styles';

export const CheckMark = styled.div<{
  state: string;
}>`
  &&& {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    height: ${pxToRem(24)};
    width: ${pxToRem(24)};
    border: ${pxToRem(1)} solid
      ${({ state, theme: { colors } }) =>
        state === 'error' ? colors.error : colors.neutral400};
    border-radius: ${pxToRem(4)};
  }
`;

export const CheckboxContainer = styled.div`
  &&& {
    height: ${pxToRem(24)};
    width: ${pxToRem(24)};
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    svg {
      position: absolute;
      opacity: 0;
      background: ${({ theme: { colors } }) => colors.light1Default};
      border-radius: ${pxToRem(4)};
      -webkit-transition: 0.4s;
      transition: 0.4s;
      left: 0;
    }
  }
`;
export const InputCheckbox = styled.input<{
  state: string;
}>`
  &&& {
    opacity: 0;
    height: 100%;
    width: 100%;
    margin: 0;
    position: relative;
    z-index: 1;
    cursor: pointer;
    border: ${pxToRem(1)} solid
      ${({ state, theme: { colors } }) =>
        state === 'error' ? colors.error : colors.neutral400};

    &:disabled {
      cursor: unset;
    }

    &:checked ~ ${CheckMark} {
      border: ${pxToRem(1)} solid
        ${({ state, theme: { colors } }) =>
          state === 'error' ? colors.error : colors.light1Default};
    }

    &:checked ~ svg {
      opacity: 1;
    }

    &:disabled ~ ${CheckMark} {
      border: ${pxToRem(1)} solid
        ${({ theme: { colors } }) => colors.neutral300};
    }

    &:disabled:checked ~ svg {
      background: ${({ theme: { colors } }) => colors.neutral300};
    }
  }
`;
